export default function BartjaLlogarive() {
    return (
        <div style={{ padding: "50px" }}>
            <h1>Ne Zhvillim</h1>
        </div>
    )
}